import React from 'react';
import PropTypes from 'prop-types';

const HeroSliderNavigation = ({ slides, onLineClick, currentSlide }) => {
  return (
    <ul className={`hero-slider-navigation current-slide-${currentSlide}`}>
      {[...Array(slides).keys()].map((i) => (
        <li key={i} onClick={() => onLineClick && onLineClick(i + 1)} >
          <div />
        </li>
      ))}
    </ul>
  );
};

HeroSliderNavigation.propTypes = {
  slides: PropTypes.number.isRequired,
  currentSlide: PropTypes.number.isRequired,
  onLineClick: PropTypes.func.isRequired
};

export default HeroSliderNavigation;
